const configApplePay = function() {
	if (!window.ApplePaySession) {
		// Do nothing.
	} else if (!ApplePaySession.canMakePayments()) {
		// Do nothing.
	}
	else {
		if ('undefined' !== typeof braintree)
		{
			var $applePayButton = isFromCheckout
				? $('.btn-apple-pay-express-checkout.btn-apple-pay')
				: $('.btn-apple-pay');

			braintree.client.create({
				authorization: brainTreeAuthorizationToken
			}, function(clientErr, clientInstance) {
				if (clientErr) {
					logError('Error creating client:', clientErr);
					return;
				}

				braintree.applePay.create({
					client: clientInstance
				}, function(applePayErr, applePayInstance) {
					if (applePayErr) {
						logError('Error creating applePayInstance:', applePayErr);
						return;
					}
					if ($applePayButton.length > 0) {
						// Set an apple pay button.
						if ($('.triggerCollapse').length > 0) {
							$('.triggerCollapse .slideUpLabel p').html('for credit card and other payments');
						}
						$applePayButton
							.click(function() {
								ga('send', 'event', 'Cart', 'Summary', 'Checkout button: Apple Pay');
								var paymentRequest = applePayInstance.createPaymentRequest({
									lineItems: getAppleLineItems(),
									total: orderTotal,
									requiredBillingContactFields: ["postalAddress"],
									requiredShippingContactFields: ["postalAddress", "email", "phone"]
								});
								var shippingMethod = '';

								var session = new ApplePaySession(3, paymentRequest);
								session.onvalidatemerchant = function(event) {
									applePayInstance.performValidation({
										validationURL: event.validationURL,
										displayName: 'Sonicelectronix'
									}, function(err, merchantSession) {
										if (err) {
											// You should show an error to the user, e.g. 'Apple Pay failed to load.'
											logError(err);
											return;
										}
										session.completeMerchantValidation(merchantSession);
									});
								};

								session.onshippingcontactselected = function(event) {
									return getSonicShipping(event.shippingContact)
										.then((result) => {
											if (result.success) {
												var status = ApplePaySession.STATUS_SUCCESS;
												var newShippingMethods = result.shippingMethod;
												var newLineItems = calculateNewLineItemsInfo(result.shippingMethod[0].identifier, result.taxValue);
												var newTotal = orderTotal;
												shippingMethod = result.shippingMethod[0].identifier;

												session.completeShippingContactSelection(status, newShippingMethods, newTotal, newLineItems);
											}
										}).catch((err) => {
											session.completePayment(ApplePaySession.STATUS_FAILURE);
										});
								};

								session.onshippingmethodselected = function(event) {
									var status = ApplePaySession.STATUS_SUCCESS;
									var newLineItems = calculateNewLineItemsInfo(event.shippingMethod.identifier);
									var newTotal = orderTotal;
									shippingMethod = event.shippingMethod.identifier;

									session.completeShippingMethodSelection(status, newTotal, newLineItems);
								};

								session.onpaymentauthorized = function(event) {
									applePayInstance.tokenize({
										token: event.payment.token
									}, function(tokenizeErr, payload) {
										if (tokenizeErr) {
											logError('Error tokenizing Apple Pay:', tokenizeErr);
											session.completePayment(ApplePaySession.STATUS_FAILURE);
											return;
										}

										$.ajax({
											dataType: 'json',
											type: 'POST',
											url: '/checkout/express/update-apple-pay-order',
											data: {
												'shippingAddress': event.payment.shippingContact,
												'billingAddress': event.payment.billingContact,
												'email': event.payment.shippingContact.emailAddress,
												'nonce': payload.nonce,
												'shippingMethod': shippingMethod
											},
											error: function() {
												session.completePayment(ApplePaySession.STATUS_FAILURE);
												return;
											},
											success: function(data) {
												if (data.hasOwnProperty('success') && !data.success) {
													if (data.hasOwnProperty('errors')) {
														session.completePayment(ApplePaySession.STATUS_FAILURE);
														return;
													} else if (data.hasOwnProperty('alertMessage')) {
														session.completePayment(ApplePaySession.STATUS_FAILURE);
														return;
													}
												}
												session.completePayment(ApplePaySession.STATUS_SUCCESS);
												window.location.href = data.redirect;
											}
										});
									});
								};
								session.begin();
							});
					}
				});
			});
		}
	}
};

let shippingCost = [], lineItems = null, orderTotal = null;

const getAppleLineItems = function (tax = null) {
	let price = parseFloat($('.checkout-price').data('price'));
	if (isNaN(price) && isFromCheckout) {
		let viewModel = $('checkout-main').viewModel();
		price = parseFloat(viewModel.Order.attr('subTotal'));
	}
	let taxAmount = (tax != null) ? tax : 0.00;
	let total = price + taxAmount;
	lineItems = [
		{
			label: "Subtotal",
			amount: price.toString()
		},
		{
			label: "Tax",
			amount: taxAmount.toString()
		}
	];
	orderTotal = {
		label: "Sonicelectronix",
		amount: total.toString()
	};
	return lineItems;
};

const getSonicShipping = function(shippingContact) {
	let addressData = {
		country: shippingContact.countryCode
	};
	if (shippingContact.hasOwnProperty('postalCode')) {
		addressData.zip = shippingContact.postalCode;
	}
	if (shippingContact.hasOwnProperty('addressLines')) {
		addressData.address = shippingContact.addressLines[0];
	}
	return new Promise(function(resolve, reject) {
		$.ajax({
			dataType: 'json',
			type: 'POST',
			url: '/checkout/express/get-shipping-details',
			data: addressData,
			error: function(err) {
				reject(err);
			},
			success: function(data) {
				if (!data.success && data.hasOwnProperty('availabilityWarnings')) {
					// International shipping, out of stock, dropship restrictions.
					let errorMessage = '';
					data.data.forEach(error => errorMessage += error.summary);
					let res = {
						"success": false,
						"error" : 'error from availabilityWarnings'
					};
					resolve(res);
				} else if (data.success && data.shippingMethod.length > 0) {
					// Clears previously set shipping option's cost.
					shippingCost = [];

					// Shipping methods.
					let shippingMethods = Object.values(JSON.parse(data.shippingMethod));
					let sonicShippingOptions = [];
					shippingMethods.forEach(method => {
						let methodObj = {
							"identifier": method.code,
							"label": method.label,
							"amount": method.fee,
							"detail": method.name
						};
						sonicShippingOptions.push(methodObj);
						shippingCost[method.code] = method.fee;
					});
					let res = {
						"success": true,
						"shippingMethod" : sonicShippingOptions,
						"taxValue": data.taxValue
					};
					resolve(res);
				} else {
					//can't find shipping method for given address
					let res = {
						"success": false,
						"error" : "Please verify your zip/postal code as FedEx is not able to calculate a rate."
					};
					resolve(res);
				}
			}
		});
	});
};

const calculateNewLineItemsInfo = function(shippingOptionId, tax = null) {
	// Sales tax.
	if (tax !== null) {
		//update tax value
		let taxObjIndex = lineItems.findIndex((obj => obj.label == "Tax"));
		lineItems[taxObjIndex].amount = tax.toString();
	}

	// Shipping cost.
	let shippingCostObj = {
		label: "Shipping cost",
		amount: shippingCost[shippingOptionId].toString()
	};

	let shippingCostObjIndex = lineItems.findIndex((obj => obj.label == "Shipping cost"));
	if (shippingCostObjIndex > -1) {
		// Object for Shipping cost already exist, so update value for it.
		lineItems[shippingCostObjIndex] = shippingCostObj;
	} else {
		//object for Shipping cost is not exist, so add it
		lineItems.push(shippingCostObj);
	}

	// Total.
	let totalPrice = 0.00;
	lineItems.forEach(item => totalPrice += parseFloat(item.amount));
	orderTotal = {
		label: "Sonicelectronix",
		amount: totalPrice.toFixed(2).toString()
	};
	return lineItems;
};

const logError = function(errorMessage) {
	let errorMsg = errorMessage.toString();
	errorMsg += '\\nurl: ' + window.location.href;
	errorMsg += ('undefined' === typeof errorMessage.stack ? '' : '\\nstack: ' + errorMessage.stack);
	if (window.hasOwnProperty('navigator')) {
		if (typeof window.navigator.userAgent !== 'undefined') {
			errorMsg += '\\nuser agent: ' + window.navigator.userAgent;
		}
	}
	let formData = new FormData();
	formData.append('error', errorMsg);
	fetch('/javascript/error', {
		method: 'POST',
		body: formData
	});
};

export default configApplePay;
